const SearchSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <g clipPath="url(#clip0_5347_67307)">
        <path
          d="M16.1648 28.2235C22.9519 28.2235 28.4537 22.7217 28.4537 15.9347C28.4537 9.1476 22.9519 3.64581 16.1648 3.64581C9.37777 3.64581 3.87598 9.1476 3.87598 15.9347C3.87598 22.7217 9.37777 28.2235 16.1648 28.2235Z"
          fill="#5D6977"
          stroke="#5D6977"
          strokeWidth="1.87838"
          strokeLinejoin="round"
        />
        <path
          d="M20.2538 11.1226C19.7174 10.5848 19.0799 10.1583 18.3782 9.86765C17.6764 9.57699 16.9241 9.42788 16.1645 9.4289C15.4049 9.42788 14.6526 9.57699 13.9508 9.86765C13.249 10.1583 12.6116 10.5848 12.0752 11.1226"
          fill="#5D6977"
        />
        <path
          d="M20.2538 11.1226C19.7174 10.5848 19.0799 10.1583 18.3782 9.86765C17.6764 9.57699 16.9241 9.42788 16.1645 9.4289C15.4049 9.42788 14.6526 9.57699 13.9508 9.86765C13.249 10.1583 12.6116 10.5848 12.0752 11.1226"
          stroke="#FCFCFC"
          strokeWidth="1.87838"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M25 24.7698L31.1336 30.9034L25 24.7698Z" fill="#5D6977" />
        <path d="M25 24.7698L31.1336 30.9034" stroke="#5D6977" strokeWidth="3.88" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5347_67307">
          <rect width="36.9444" height="36.9444" fill="white" transform="translate(-0.972656 -0.972229)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchSvg;
